/**
 * 汎用 localStorage 読み書き utility。
 *
 * 読み書きとも例外を握りつぶし「未設定」扱いにフォールバックする (Safari private
 * mode 等 Web Storage が throw する環境向け)。このパターンは既存の
 * `~/i18n/index.ts` (`getCachedLang` / `setCachedLang`) や
 * `~/components/layouts/MainLayout/secondaryMenuAutoOpen.ts` の
 * sessionStorage 版と同じ既存慣習に揃えている。
 *
 * 同時同量ダッシュボード (需要 `BalanceDemand` / 発電 `BalanceGeneration`) の
 * グリッドレイアウト永続化 (`~/hooks/useGridCardLayout`) から使う。
 *
 * [spec差異] doji-bg.md AC-BDB-037 は自動保存の失敗を「通信エラー・サーバー
 * エラー」で失敗しうる前提 (= サーバー永続化) で書いているが、グリッド
 * レイアウトの保存は localStorage への同期・ローカル書き込みであり、通信エラー・
 * サーバーエラーは発生しないため、AC-BDB-037 のエラーバナー処理は本実装では
 * 対象外とする。
 */

/** 指定 key の localStorage 値を読む。未設定・例外時は undefined。 */
export function getLocalStorageItem(key: string): string | undefined {
  try {
    return localStorage.getItem(key) ?? undefined
  } catch {
    return undefined
  }
}

/** 指定 key に value を書き込む。例外は握りつぶす (書き込み失敗は無視)。 */
export function setLocalStorageItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    // localStorage 不可環境 (Safari private mode 等) では silent ignore
  }
}

/** 指定 key を削除する。例外は握りつぶす。 */
export function removeLocalStorageItem(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // localStorage 不可環境では silent ignore
  }
}
